export const MODISLayerIDs = [
  {
    id: 'MODIS48',
    layerIds: [21],
    type: 'dynamic',
    url: '',
  },
  {
    id: 'MODIS72',
    layerIds: [21],
    type: 'dynamic',
    url: '',
  },
  {
    id: 'MODIS7D',
    layerIds: [21],
    type: 'dynamic',
    url: '',
  },
  {
    id: 'MODIS1Y',
    layerIds: [21],
    type: 'dynamic',
    url: '',
  },
];
